import { getFormattedFloat } from './getFormattedFloat';

export const getGridFormattedFloat = (value: any, column: any) => {
  if (column.formatItem || column.format) {
    // Split the value with appended characters (e.g. "1000,00 EUR")
    const splittedValue = String(value).trim().split(' ');

    if (splittedValue.length > 1) {
      const reformatted = getFormattedFloat(splittedValue[0].replace(',', '.'));
      const newValue = reformatted + ' ' + splittedValue[1];
      return newValue.replace('.', ',');
    }
  }

  return getFormattedFloat(String(value));
};
